import PropTypes from 'prop-types'
import { Box, HStack, Image, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import IconsChevronRight from '../../../assets/icons/icons-chevron-right.svg'

export default function Promotion({
  promotionDescription,
  shopId,
  establishmentId,
  shopName,
  endDate,
  onClick,
}) {
  return (
    <Box w="100%" boxSizing="border-box" padding="0px 10px 0px 10px">
      <HStack
        mb={1}
        w="100%"
        cursor="pointer"
        onClick={onClick}
        borderRadius="7px"
        backgroundColor="#EEEEEE"
      >
        <Image
          src={`https://assetsamipass.blob.core.windows.net/commerces/${establishmentId}/${shopId}/logo.png`}
          width="80px"
          height="80px"
          padding={2}
          borderRadius={100}
        />
        <VStack flex={1} alignItems="flex-start" spacing={0}>
          <Text variant="subtitle2" color="#000000">
            {shopName}
          </Text>
          <Text variant="body3">{promotionDescription}</Text>
          <Text variant="body3" pt={1}>
            Vigente hasta{' '}
            {format(new Date(endDate), 'dd-MM-yyyy', { locale: es })}
          </Text>
        </VStack>
        <Box width={10}>
          <img src={IconsChevronRight} alt="icon" />
        </Box>
      </HStack>
    </Box>
  )
}

Promotion.propTypes = {
  onClick: PropTypes.func,
  promotionDescription: PropTypes.string,
  shopId: PropTypes.string,
  establishmentId: PropTypes.string,
  shopName: PropTypes.string,
  endDate: PropTypes.string,
}
